import { render, staticRenderFns } from "./EditPicks.vue?vue&type=template&id=34d5feff&"
import script from "./EditPicks.vue?vue&type=script&lang=js&"
export * from "./EditPicks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports